<template>
  <div class="container" id="carefully">
    <div class="header flex-cen flex-ter rel">
      <div @click="retractClick()" class="retract abs flex-cen flex-ter">
        {{ retract ? t('展开') : t('收起') }}
        <i :class="`iconfont ${!retract ? 'icon-chakanwuliuguiji_shouqi' : 'icon-chakanwuliuguiji_zhankai'}`"></i>
      </div>
    </div>

    <el-collapse-transition>
      <div class="content" v-show="!retract">
        <div class="topic">■ 最強出荷スピード保証(D2C対応可)</div>
        <div class="detail">
          <span class="sub">· 48時間納品</span>
          <span>一部工場では24時間以内のスピード発送が可能,すべての商品が48時間以内に出荷可能</span>
        </div>
        <div class="detail">
          <span class="sub">· 在庫保障</span>
          <span>他のサービスよりも優先して在庫確保可能!! ※一部のサプライヤーから順次開始します</span>
        </div>
        <div class="detail">
          <span class="sub">· ロット数1点から買付可能 </span>
          <span>ロット数1点から買付可能な工場を順次拡充,D2Cビジネスユーザーにメリット</span>
        </div>
        <div class="topic">■ 上位2.5％厳選品質</div>
        <div class="detail">
          <span class="sub">· 1688 オフィシャル厳選品質</span>
          <span>B2B卸売市場主要のサイトー1688の商品の中で優良な1億点を厳選!!</span>
        </div>
        <div class="detail">
          <span class="sub">· 不良品7日以内無料交換</span>
          <span>7日間無条件返品商品厳選！CKB倉庫まで到着後1週間以内なら交換可能！※返品手数料は除く</span>
        </div>
        <div class="detail">
          <span class="sub">· 人気商品検索機能</span>
          <span>1688 オフィシャルサイトで人気の商品＆高評価率95％以上の商品をフィルタリサーチ可能</span>
        </div>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { t } from '@/plugins/i18n'
import bus from '@/util/useBus'
const storageRetract = localStorage.getItem('__selected_retract__') || false
// 是否收起
const retract = ref(storageRetract)

// 收起点击
const retractClick = (open = !retract.value) => {
  retract.value = open
  if (!localStorage.getItem('__selected_retract__')) {
    localStorage.setItem('__selected_retract__', true)
  }
}

onMounted(() => {
  bus.on('goCarefully', () => {
    document.querySelector('#carefully').scrollIntoView({ block: 'center', behavior: 'smooth' })
    retractClick(false)
  })
})

</script>

<style lang="scss" scoped>
.container {
  .header {
    background: url(https://static-jp.theckb.com/static-asset/client/privilegeBg1.png);
    background-size: contain;
    height: 70px;

    .logo {
      left: 20px;
      top: 12px;
      width: 161px;
      height: 16px;
    }

    .banner-icon {
      width: 32px;
      height: 20px;
      margin-top: -20px;
    }

    .retract {
      right: 20px;
      top: 22px;
      padding: 0 10px;
      height: 25px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 13px;
      font-size: 12px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 25px;
      cursor: pointer;

      .iconfont {
        font-size: 10px;
        font-weight: 100;
        margin-left: 3px;
      }
    }

    .title {
      font-size: 26px;
      font-weight: 800;
      color: #FFFFFF;
      line-height: 38px;
      text-shadow: 0px 2px 8px #BA4200;
      background: linear-gradient(360deg, #FFE2CB 0%, #FFFFFF 100%);
      -webkit-background-clip: text;
    }
  }

  .content {
    background: linear-gradient(180deg, #FFFFFF 0%, #FFF3EA 100%);
    border-radius: 0px 0px 4px 4px;
    box-sizing: border-box;
    padding: 0 20px;
    padding-bottom: 20px;

    .topic {
      padding-top: 20px;
      font-size: 14px;
      font-weight: 600;
      color: #333333;
      line-height: 20px;
      padding-bottom: 8px;
    }

    .detail {
      font-size: 12px;
      color: #777777;
      line-height: 26px;
      font-weight: 400;

      .sub {
        color: #333333;
        font-weight: bold;
        padding-right: 10px;
        .redtxt{
          /*color: #FD3800;*/
          font-weight: normal;
        }
      }
    }

  }
}
</style>
